import React, { useEffect, useState } from 'react'
import './Payroll.scss'
import { salaryService } from 'Services/salaryService'
import { CurrencyFormatter } from 'Helpers'
import { ModalWrapper } from 'Components'
import EMoney from 'Assets/Images/e-money.png'
import BankIcon from 'Assets/Images/bank.png'
import HashIcon from 'Assets/Images/hash.png'
import DollarIcon from 'Assets/Images/chair-dollar.png'
import TinIcon from 'Assets/Images/nin-like.png'
import FlagIcon from 'Assets/Images/residence-like.png'
import PensionUpdate from './Modals/PensionUpdate/PensionUpdate'
import BankUpdate from './Modals/BankUpdate/BankUpdate'
import TaxUpdate from './Modals/TaxUpdate/TaxUpdate'
import QuestionIcon from 'Assets/Icons/message-question.svg'
import { Link } from 'react-router-dom'
import { EmployeeSingleType } from 'Models/employeeType'
import { maskAccount } from 'Helpers/MaskedAccount'

type Props = {
  profile: EmployeeSingleType | null | undefined
  setProfile: any
}

const Payroll = ({ profile }: Props) => {
  const [netPay, setNetPay] = useState<number>(0)
  const [basicEarnings, setBasicEarnings] = useState<number>()
  const [leaveAllowance, setLeaveAllowance] = useState<number>()

  const getSalary = async () => {
    try {
      const response = await salaryService.getSalaryV2(profile?.id)
      // console.log('response', response)

      const dataset = response.data.data?.dataset ?? []

      const firstRow = dataset[0]

      const earning = firstRow?.earnings ?? []
      const deduction = firstRow?.deductions ?? []
      const allowance = firstRow?.allowances ?? []

      const totalEarnings = earning.reduce(
        (sum: number, item: { amount: number }) => sum + (item.amount || 0),
        0,
      )

      const totalDeductions = deduction.reduce(
        (sum: number, item: { amount: number }) => sum + (item.amount || 0),
        0,
      )

      // setNetPay(totalEarnings - totalDeductions)
      setNetPay(firstRow === undefined || !firstRow ? '0.00' : firstRow?.netPay)

      const basic = earning.find((item: any) => item.category === 'Basic Salary')
      const leave = allowance.find((item: any) => item.category === 'Leave Allowance')

      setBasicEarnings(basic?.amount ?? 0)
      setLeaveAllowance(leave?.amount ?? 0)
    } catch (error) {
      console.error('getSalary error', error)
      setNetPay(0)
      setLeaveAllowance(0)
    }
  }
  useEffect(() => {
    if (!profile?.id) return
    getSalary()
  }, [profile?.id])

  const [showModal, setShowModal] = useState(false)
  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const [showModalPension, setShowModalPension] = useState(false)
  const toggleModalPension = () => {
    setShowModalPension((prevState) => !prevState)
  }

  const [showModalTax, setShowModalTax] = useState(false)
  const toggleModalTax = () => {
    setShowModalTax((prevState) => !prevState)
  }

  return (
    <div className='admin-payroll-info'>
      <div className='d-flex align-items-center request-con d-none'>
        <div className='d-flex align-items-center gap-2'>
          <img className='ms-4' src={QuestionIcon} alt='icon' />
          <p className='remove-it'>Pual Requested to update Bank Details</p>
        </div>
        <div className='ms-auto head-btn d-flex gap-3 me-4'>
          <button className='payroll-btn payroll-green'>Approve</button>
          <button className='payroll-btn payroll-red'>Decline</button>
        </div>
      </div>
      <div className='container-fluid m-0 p-0 salaryAllowance mt-4'>
        <div className='row g-4'>
          <div className='col-lg-6'>
            <div className='card'>
              <div className='card-body d-flex justify-content-between mt-2'>
                <div className='salary'>
                  <h6>Net Pay</h6>
                  <h2 className='mt-3'>₦{CurrencyFormatter(Number(netPay))}</h2>
                </div>
                <div className='img-con'>
                  <img src={EMoney} alt='icon' />
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='card'>
              <div className='card-body mt-2'>
                <div className='salary'>
                  <h6>Leave Allowance</h6>
                  <h2 className='mt-3'>₦{CurrencyFormatter(Number(leaveAllowance))}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container-fluid mt-4 p-0 statutory'>
        <div className='row g-4'>
          <div className='col-lg-4'>
            <div className='card'>
              <div className='card-body mt-2'>
                <div className='bank-details-h line'>
                  <h6 className='heading'>bank details</h6>
                </div>
                <div className='bank-details line'>
                  <div className='icon-head'>
                    <img src={BankIcon} alt='' />
                    <h6>Bank</h6>
                  </div>
                  <h6
                    className={`${profile?.bankName === null || profile?.bankName === 'string' ? 'sub-not' : 'sub'} `}
                  >
                    {profile?.bankName === 'string' || profile?.bankName === null
                      ? 'Not Provided'
                      : profile?.bankName}
                  </h6>{' '}
                </div>
                <div className='bank-details'>
                  <div className='icon-head'>
                    <img src={HashIcon} alt='' />
                    <h6>Account Number</h6>
                  </div>
                  <h6
                    className={`${profile?.bankAccountNumber === null || profile?.bankAccountNumber === 'string' ? 'sub-not' : 'sub'} `}
                  >
                    {profile?.bankAccountNumber === 'string' || profile?.bankAccountNumber === null
                      ? 'Not Provided'
                      : maskAccount(profile?.bankAccountNumber)}
                  </h6>{' '}
                </div>

                <p className='others'>Account number is masked for security reasons.</p>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='card'>
              <div className='card-body mt-2'>
                <div className='bank-details-h line'>
                  <h6 className='heading'>Pension Details</h6>
                </div>
                <div className='bank-details line'>
                  <div className='icon-head'>
                    <img src={DollarIcon} alt='icon' />
                    <h6>PFA</h6>
                  </div>
                  <h6 className={`${profile?.pfa === null ? 'sub-not' : 'sub'} `}>
                    {profile?.pfa ?? 'Not Provided'}
                  </h6>{' '}
                </div>
                <div className='bank-details'>
                  <div className='icon-head'>
                    <img src={HashIcon} alt='' />
                    <h6>RSA Number</h6>
                  </div>
                  <h6 className={`${profile?.rsaNumber === null ? 'sub-not' : 'sub'} `}>
                    {profile?.rsaNumber ?? 'Not Provided'}
                  </h6>{' '}
                </div>

                <p className='others'>Retirement Savings Account number issued by your PFA.</p>
              </div>
            </div>
          </div>

          <div className='col-lg-4'>
            <div className='card'>
              <div className='card-body mt-2'>
                <div className='bank-details-h line'>
                  <h6 className='heading'>Tax Details</h6>
                </div>
                <div className='bank-details line'>
                  <div className='icon-head'>
                    <img src={TinIcon} alt='' />
                    <h6>Tax ID (TIN)</h6>
                  </div>
                  <h6 className={`${profile?.taxId === null ? 'sub-not' : 'sub'} `}>
                    {profile?.taxId ?? 'Not Provided'}
                  </h6>{' '}
                </div>
                <div className='bank-details'>
                  <div className='icon-head'>
                    <img src={FlagIcon} alt='' />
                    <h6>Residential State</h6>
                  </div>
                  <h6 className={`${profile?.state === null ? 'sub-not' : 'sub'} `}>
                    {profile?.state ?? 'Not Provided'}
                  </h6>{' '}
                </div>

                <p className='others'>
                  Tax deductions are calculated based on your state of residence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-5 btn-link-wrapper'>
        <Link
          to={`/admin/user/payroll-edit/${profile?.id}`}
          className='ps-3 pe-3 reset-btn-as-link'
        >
          Edit Payroll & Statutory Details
        </Link>
      </div>
      <div className='footer'>
        <span>Last updated: NA</span>
        <span>Updated by: NA</span>
      </div>

      <ModalWrapper
        showModal={showModal}
        closeModal={toggleModal}
        title={<span className='custom-modal-title'> Bank Details</span>}
      >
        <BankUpdate toggleModal={toggleModal}></BankUpdate>
      </ModalWrapper>

      <ModalWrapper
        showModal={showModalPension}
        closeModal={toggleModalPension}
        title={<span className='custom-modal-title'>Pension Details</span>}
      >
        <PensionUpdate toggleModal={toggleModalPension}></PensionUpdate>
      </ModalWrapper>

      <ModalWrapper
        showModal={showModalTax}
        closeModal={toggleModalTax}
        title={<span className='custom-modal-title'>Tax Details</span>}
      >
        <TaxUpdate toggleModal={toggleModalTax}></TaxUpdate>
      </ModalWrapper>
    </div>
  )
}

export default Payroll
